import { useHistory, useLocation } from "react-router";

/**
 * Pass this as the location state when pushing a screen that has a back arrow
 * or a cancel button, so that screen knows it is safe to go back:
 *
 *   history.push(`/smartfolios/${id}`, CAME_FROM_APP);
 */
export const CAME_FROM_APP = { cameFromApp: true };

/**
 * Returns the previous screen when we pushed it ourselves, and the fallback
 * route otherwise — a deep link, a new tab, or a shared URL.
 *
 * Pushing a fixed route unconditionally throws away where the user came from:
 * filters, tabs and scroll position on the previous screen are all lost. But
 * going back unconditionally is worse — the entry behind a deep link belongs to
 * whoever linked us (an email, Slack), so back would leave the app entirely.
 * The state set at push time is the only reliable answer; history.length counts
 * the whole tab, not our app.
 */
export const useGoBackOr = (fallback: string) => {
  const history = useHistory();
  const location = useLocation<{ cameFromApp?: boolean } | undefined>();

  return () => {
    if (location.state?.cameFromApp) history.goBack();
    else history.push(fallback);
  };
};
